import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
// PAGES
import Menu from '../../pages/Menu/Menu';
import AboutUs from '../../pages/AboutUs/AboutUs';
import Blog from '../../pages/Blog/Blog';
import Careers from '../../pages/Careers/Careers';
import Contact from '../../pages/Contact/Contact';
import CouponsAndDeals from '../../pages/CouponsAndDeals/CouponsAndDeals';
import TermsAndConditions from '../../pages/TermsAndConditions/TermsAndConditions';
import PrivacyPolicy from '../../pages/PrivacyPolicy/PrivacyPolicy';
import IceCreamChallenge from '../../pages/IceCreamChallenge/IceCreamChallenge';
import Accessibility from '../../pages/Accessibility/Accessibility';
import FAQ from '../../pages/FAQ/FAQ';
import Locations from '../../pages/Locations/Locations';
import NoMatch from '../../pages/PageContainer/NoMatch';
import Loyalty from '../../pages/Loyalty/Loyalty';
import GiftCard from '../../pages/GiftCard/GiftCard';
import GiftCardLanding from '../../pages/GiftCardLanding/GiftCardLanding';
import Events from '../../pages/Events/Events';
import DoughProPayments from '../../pages/DoughProPayments/DoughProPayments';
import DoughProFreeCookie from '../../pages/DoughProFreeCookie/DoughProFreeCookie';
import DoughProTermsConditions from "../../pages/DoughProTermsConditions/DoughProTermsConditions";
import Product from '../../pages/Product/Product';
import VeganGlutenFree from '../../pages/VeganGlutenFree/VeganGlutenFree';
import DoughProGiftCardPurchase from "../../pages/DoughProGiftCardPurchase/DoughProGiftCardPurchase";
import Countries from "../../pages/Countries/Countries";
import AllergenAndNutritionInfo from "../../pages/AllergenAndNutritionInfo/AllergenAndNutritionInfo";
import ValentinesReservations from "../../pages/ValentinesReservations/ValentinesReservations";
import SnackMadness from "../../pages/SnackMadness/SnackMadness";
// CONSTANTS
import endpoints from '../../shared/constants/endpoints';
import CookiemagicRoute from '../ProtectedRoutes/CookiemagicRoute';
import Homepage from '../../pages/Homepage/Homepage';
import Donations from '../../pages/Donations/Donations';

import ChangePassword from '../../pages/ChangePassword/ChangePassword';
import ResetPassword from '../../pages/ResetPassword/ResetPassword';
import PasswordlessLogin from '../../pages/PasswordLessAuth/Login/Login';
import PasswordlessCreateAccount from '../../pages/PasswordLessAuth/CreateAccount/CreateAccount';
import InsomniaRewards from '../../pages/InsomniaRewards/InsomniaRewards';
import InsomniaRewardsTerms from '../../pages/InsomniaRewardsTerms/InsomniaRewardsTerms';
import Store from '../../pages/Store/Store';
import Gifting from '../../pages/Gifting/Gifting';
import NewsIndex from '../../pages/News/NewsIndex';
import NewsArticle from '../../pages/News/NewsArticle';
import NewsMedia from '../../pages/News/NewsMedia';

const IndexRoutes = () => (
  <Switch>
    <Route path="/donations" exact component={Donations} />
    <Route path="/store/:slug" component={Store} />
    <Route path="/shop-gift-cards" component={Menu} />
    <Route path="/menu/:id" component={Menu} />
    <Route path="/menu" component={Menu} />
    <Route path="/shipping" component={Menu} />
    <Route path="/home/address" component={Homepage} />
    <Route path="/about" component={AboutUs} />
    <Route path="/blog" component={Blog} />
    <Route path="/allergen-and-nutrition-info" component={AllergenAndNutritionInfo} />
    <Route path="/careers" component={Careers} />
    <Route path="/contact/:tabId?/:subsectionId?" component={Contact} />
    <Route path="/privacy-policy" component={PrivacyPolicy} />
    <Route path="/icecreamchallenge" component={IceCreamChallenge} />
    <Route path="/faq" component={FAQ} />
    <Route path="/gifting" component={Gifting} />
    <Route path={`${endpoints.newsMedia}/:type`} component={NewsMedia} />
    <Redirect exact from={endpoints.newsMedia} to={`${endpoints.newsMedia}/images`} />
    <Route path={`${endpoints.news}/:slug`} component={NewsArticle} />
    <Route path={endpoints.news} exact component={NewsIndex} />
    <Redirect from="/newsroom" to={endpoints.news} />
    <Route path="/accessibility" component={Accessibility} />
    <Route path="/terms" render={() => <TermsAndConditions key="terms" path="terms" />} />
    <Route
      path="/cookielab-event-space-terms-and-conditions"
      render={() => <TermsAndConditions key="cookielab" path="cookielab" />}
    />
    <Route
      path="/snack-madness-sweeps-terms-and-conditions"
      render={() => <TermsAndConditions key="snack-madness-sweeps" path="snack-madness-sweeps" />}
    />
    <Route
      path={endpoints.dreamDormGiveawayTerms}
      render={() => (
        <TermsAndConditions key="dream-dorm-room-giveaway" path="dream-dorm-room-giveaway" />
      )}
    />
    <Route
      path={endpoints.insomnia23rdBirthdayGiveawayTerms}
      render={() => (
        <TermsAndConditions
          key="insomnia-23rd-birthday-terms-and-conditions"
          path="insomnia-23rd-birthday-terms-and-conditions"
        />
      )}
    />
    <Route path="/change-password/:key" component={ChangePassword} />
    <Route path="/reset-password" component={ResetPassword} />
    <Route path="/login" component={PasswordlessLogin} />
    <Route path="/create-account" component={PasswordlessCreateAccount} />
    <Route path={`${endpoints.locations}/store/:store_id`} component={Locations} />
    <Route path={`${endpoints.locations}/:store_id`} component={Locations} />
    <Route path={endpoints.locations} component={Locations} />
    <Route path="/single-product" component={Product} />
    <Route path="/loyalty" component={Loyalty} />
    <Route path="/insomniarewards" exact component={InsomniaRewards} />
    <Route path="/insomniarewards/terms" component={InsomniaRewardsTerms} />
    <Route path="/gift-card" component={GiftCard} />
    <CookiemagicRoute path={endpoints.cookieMagicGiftCardPurchase} component={GiftCardLanding} />
    <Route path="/events" component={Events} />
    <Route path="/events" component={Events} />
    <Route path="/coupons-and-deals" component={CouponsAndDeals} />
    {/* <CookiemagicRoute path={endpoints.doughProPage} component={DoughPro} /> */}
    <CookiemagicRoute path={endpoints.doughProPaymentsPage} component={DoughProPayments} />
    <CookiemagicRoute path={endpoints.doughProFreeCookiePage} component={DoughProFreeCookie} />
    <CookiemagicRoute path={endpoints.doughProTermsConditions} component={DoughProTermsConditions} />
    <Route path={endpoints.veganGlutenFreePage} component={VeganGlutenFree} />
    <CookiemagicRoute path="/cookiemagic-egift-product/:id" component={DoughProGiftCardPurchase} />
    <Route path="/goto/store/:store_id" component={Menu} />
    <Route path="/countries" component={Countries} />
    <Route path="/valentines-reservations" component={ValentinesReservations} />
    <Route path="/" exact component={Homepage} />
    <Route path="/bracket" component={SnackMadness} />
    <Route path="/">
      <Redirect to="/" />
    </Route>
    <Route path="/404" component={NoMatch} />

    <Redirect to="/404" />
  </Switch>
);

export default IndexRoutes;
